import React, { useContext, useEffect, useState } from "react";
import {
    Container,
    Table,
    Button,
    Row,
    Col,
    Input,
    Label
} from "reactstrap";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Header from "../../components/Headers/Header";
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import { AuthContext } from "../../context/AuthContext";
import { AlunoContext } from "../../context/AlunoContext";
import { TerceiroContext } from '../../context/TerceiroContext';
import { CursoContext } from '../../context/CursoContext';
import { ContratoContext } from "../../context/ContratoContext";
import { PreparacaoAlbumContext } from "../../context/PreparacaoAlbumContext";
import { RelatorioVendaContext } from "../../context/RelatorioVendaContext";
import { EditAlunoModal } from "../../components/Aluno/EditAlunoModal";
import { EditAlunoType } from "../../context/hooks/useAluno";

const AlunoDetalhado = () => {
    const { objUserTk } = useContext(AuthContext);
    const { getAlunosDetalhadosPaged, listAlunoDetalhado, alunoDetalhadoPageCount, handleGetAlunoById } = useContext(AlunoContext);
    const { handleGetVendedoresByEmpresa, listVendedores } = useContext(TerceiroContext);
    const { handleGetCursoByEmpresaId, listCurso } = useContext(CursoContext);
    const { handleGetContratoByEmpresaId, listContrato } = useContext(ContratoContext);
    const { handleGetAlbumByEmpresaId, listPreparacaoAlbum } = useContext(PreparacaoAlbumContext);
    const { handleGetRelatorioByEmpresaId, listRelatorioVenda } = useContext(RelatorioVendaContext);

    const [loading, setLoading] = useState(true);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [alunoSelecionado, setAlunoSelecionado] = useState<EditAlunoType | null>(null);
    const [contratoIdSelecionado, setContratoIdSelecionado] = useState<number | undefined>(undefined);
    const [cursoIdSelecionado, setCursoIdSelecionado] = useState<number | undefined>(undefined);
    const [dataSearch, setDataSearch] = useState({
        name: "",
        alunoId: "",
        cursoId: "",
        contratoId: "",
        relatorioId: "",
        albumId: "",
        cidade: ""
    });

    useEffect(() => {
        if (objUserTk?.EmpresaId) {
            setLoading(true);

            Promise.all([
                handleGetCursoByEmpresaId(objUserTk.EmpresaId),
                handleGetVendedoresByEmpresa(objUserTk.EmpresaId),
                handleGetContratoByEmpresaId(objUserTk.EmpresaId),
                handleGetAlbumByEmpresaId(objUserTk.EmpresaId),
                handleGetRelatorioByEmpresaId(objUserTk.EmpresaId),
            ]).then(() => {
                return getAlunosDetalhadosPaged(1, objUserTk.EmpresaId, 10);
            })
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
        }
    }, [objUserTk.EmpresaId]);

    const onChangePagination = async (e: any, value: number) => {
        await getAlunosDetalhadosPaged(
            value,
            objUserTk.EmpresaId,
            10,
            dataSearch.name,
            dataSearch.alunoId ? parseInt(dataSearch.alunoId) : undefined,
            dataSearch.contratoId ? parseInt(dataSearch.contratoId) : undefined,
            dataSearch.relatorioId ? parseInt(dataSearch.relatorioId) : undefined,
            dataSearch.albumId ? parseInt(dataSearch.albumId) : undefined,
            dataSearch.cidade,
            dataSearch.cursoId ? parseInt(dataSearch.cursoId) : undefined
        );
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, [e.target.name]: e.target.value });
    };

    const handleSearch = () => {
        setLoading(true);
        getAlunosDetalhadosPaged(
            1,
            objUserTk.EmpresaId,
            10,
            dataSearch.name,
            dataSearch.alunoId ? parseInt(dataSearch.alunoId) : undefined,
            dataSearch.contratoId ? parseInt(dataSearch.contratoId) : undefined,
            dataSearch.relatorioId ? parseInt(dataSearch.relatorioId) : undefined,
            dataSearch.albumId ? parseInt(dataSearch.albumId) : undefined,
            dataSearch.cidade,
            dataSearch.cursoId ? parseInt(dataSearch.cursoId) : undefined
        )
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleClear = () => {
        setDataSearch({
            name: "",
            alunoId: "",
            cursoId: "",
            contratoId: "",
            relatorioId: "",
            albumId: "",
            cidade: ""
        });
        setLoading(true);
        getAlunosDetalhadosPaged(1, objUserTk.EmpresaId, 10)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleEditarAluno = async (alunoId: number, contratoId?: number, cursoId?: number) => {
        const aluno = await handleGetAlunoById(alunoId);
        if (!aluno) return;
        setAlunoSelecionado({
            id: aluno.id,
            referenceCode: aluno.referenceCode,
            name: aluno.name,
            email: aluno.email,
            cpf: aluno.cpf,
            address: aluno.address,
            addressNumber: aluno.addressNumber,
            neighborhood: aluno.neighborhood,
            city: aluno.city,
            state: aluno.state,
            zipCode: aluno.zipCode,
            landline: aluno.landline,
            telephone_01: aluno.telephone_01,
            telephone_02: aluno.telephone_02,
            telephone_03: aluno.telephone_03,
            telephone_04: aluno.telephone_04,
            telephone_05: aluno.telephone_05,
            telephone_06: aluno.telephone_06,
            facebook: aluno.facebook,
            instagram: aluno.instagram,
            keepThePhotos: aluno.keepThePhotos,
            hasAlbum: aluno.hasAlbum,
            numberOfPhotos: aluno.numberOfPhotos,
            base64Image: aluno.base64Image,
        });
        setContratoIdSelecionado(contratoId);
        setCursoIdSelecionado(cursoId);
        setEditModalOpen(true);
    };

    const handleAlunoAtualizado = () => {
        getAlunosDetalhadosPaged(
            1,
            objUserTk.EmpresaId,
            10,
            dataSearch.name,
            dataSearch.alunoId ? parseInt(dataSearch.alunoId) : undefined,
            dataSearch.contratoId ? parseInt(dataSearch.contratoId) : undefined,
            dataSearch.relatorioId ? parseInt(dataSearch.relatorioId) : undefined,
            dataSearch.albumId ? parseInt(dataSearch.albumId) : undefined,
            dataSearch.cidade,
            dataSearch.cursoId ? parseInt(dataSearch.cursoId) : undefined
        );
    };

    const getRelacaoStatusLabel = (status: number) => {
        switch (status) {
            case 1:
                return "Em rota";
            case 2:
                return "Roteiro";
            case 3:
                return "Retorno";
            case 4:
                return "Devolvido";
            case 5:
                return "Vendido";
            case 6:
                return "Descartado";
            case 7:
                return "Recusou Álbum";
            default:
                return "Desconhecido";
        }
    }

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar brandText="Álbum dos Alunos" search={false} titleSearch="" />
            <Container className="mt-5">
                <Row className="align-items-end mb-4">
                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="name">Nome</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            placeholder="Buscar por nome"
                            value={dataSearch.name}
                            onChange={handleSearchChange}
                        />
                    </Col>
                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="alunoId">Cód. Aluno</Label>
                        <Input
                            className="form-control-alternative"
                            type="number"
                            name="alunoId"
                            placeholder="Código do aluno"
                            value={dataSearch.alunoId}
                            onChange={handleSearchChange}
                        />
                    </Col>
                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="cursoId">Curso</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="cursoId"
                            value={dataSearch.cursoId}
                            onChange={handleSearchChange}
                        >
                            <option value="">Selecione um Curso</option>
                            {listCurso.map((curso) => (
                                <option key={curso.id} value={curso.id}>
                                    {curso.name}
                                </option>
                            ))}
                        </Input>
                    </Col>
                </Row>

                <Row className="align-items-end mb-4">
                    <Col xs="12" md="3" lg="3" className="mb-2">
                        <Label className="form-control-label" for="contratoId">Contrato</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="contratoId"
                            value={dataSearch.contratoId}
                            onChange={handleSearchChange}
                        >
                            <option value="">Selecione um Contrato</option>
                            {listContrato.map((contrato) => (
                                <option key={contrato.id} value={contrato.id}>
                                    {`${contrato.id}`}
                                </option>
                            ))}
                        </Input>
                    </Col>
                    <Col xs="12" md="3" lg="3" className="mb-2">
                        <Label className="form-control-label" for="relatorioId">Relatório</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="relatorioId"
                            value={dataSearch.relatorioId}
                            onChange={handleSearchChange}
                        >
                            <option value="">Selecione um Relatório</option>
                            {listRelatorioVenda.map((relatorio) => (
                                <option key={relatorio.id} value={relatorio.id}>
                                    {`${relatorio.id}`}
                                </option>
                            ))}
                        </Input>
                    </Col>
                    <Col xs="12" md="3" lg="3" className="mb-2">
                        <Label className="form-control-label" for="cidade">Cidade</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="cidade"
                            placeholder="Buscar por cidade"
                            value={dataSearch.cidade}
                            onChange={handleSearchChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex align-items-end justify-content-end mb-2">
                        <div>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                onClick={handleSearch}
                                className="mr-2"
                            >
                                Buscar
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                onClick={handleClear}
                            >
                                Limpar
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Table hover responsive className="table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Código ref.</th>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Curso</th>
                            <th>Contrato ID</th>
                            <th>Relatório ID</th>
                            <th>Vendedor ID</th>
                            <th>Vendedor</th>
                            <th>Instituição</th>
                            <th>Cidade</th>
                            <th>Fotos</th>
                            <th>Status</th>
                            <th>Justificativa</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listAlunoDetalhado.map((aluno, index) => (
                            <tr key={index}>
                                <td>{aluno.alunoId}</td>
                                <td>{aluno.referenceCode}</td>
                                <td style={{ textAlign: "center" }}>
                                    {aluno.base64Image ? (
                                        <img
                                            src={aluno.base64Image}
                                            alt={`Foto de ${aluno.alunoNome}`}
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                boxShadow: "0 0 3px rgba(0,0,0,0.3)"
                                            }}
                                            title={aluno.alunoNome}
                                        />
                                    ) : (
                                        <div
                                            title={aluno.alunoNome}
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                backgroundColor: "#ccc"
                                            }}
                                        />
                                    )}
                                </td>
                                <td>{aluno.alunoNome}</td>
                                <td>{aluno.email}</td>
                                <td>{aluno.cursoNome}</td>
                                <td>{aluno.contratoId}</td>
                                <td>{aluno.relatorioId ?? "-"}</td>
                                <td>{aluno.vendedorId ?? "-"}</td>
                                <td>{aluno.vendedorNome ?? "-"}</td>
                                <td>{aluno.instituicaoNome ?? "-"}</td>
                                <td>{aluno.cidade ?? "-"}</td>
                                <td>{aluno.numeroFotos ?? 0}</td>
                                <td>{getRelacaoStatusLabel(Number(aluno.status)) ?? "-"}</td>
                                <td title={aluno.status === 7 ? aluno.justificativaRecusa : undefined}>
                                    {aluno.status === 7
                                        ? (aluno.justificativaRecusa && aluno.justificativaRecusa.length > 40
                                            ? aluno.justificativaRecusa.substring(0, 40) + "…"
                                            : aluno.justificativaRecusa ?? "—")
                                        : "—"}
                                </td>
                                <td>
                                    <Button onClick={() => handleEditarAluno(aluno.alunoId, aluno.contratoId, aluno.cursoId)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <div className="d-flex justify-content-end mt-3">
                    {alunoDetalhadoPageCount > 1 && (
                        <PaginationMaterial
                            onChange={onChangePagination}
                            count={alunoDetalhadoPageCount}
                        />
                    )}
                </div>
            </Container>
            <EditAlunoModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                aluno={alunoSelecionado}
                contratoId={contratoIdSelecionado}
                cursoId={cursoIdSelecionado}
                onAlunoAtualizado={handleAlunoAtualizado}
            />
        </>
    );
};

export default AlunoDetalhado;
